import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'Is it paper or digital?',
  a: 'It is a 100% digital product (High-Resolution PDF) optimised for iPad, Tablet, Laptop, and Smartphone.'
}, {
  q: 'Do I need experience teaching swimming?',
  a: 'No. The system is designed for both new instructors in their first season and experienced coaches who want a better planning structure.'
}, {
  q: 'Does it work for group lessons?',
  a: 'Yes. The lessons, programs, and templates are designed for both individual and group environments — including mixed-ability classes.'
}, {
  q: 'Can I use it at community pools and aquatic centres?',
  a: 'Absolutely. The system was created specifically for real-world aquatic teaching environments.'
}, {
  q: 'How quickly will I see results?',
  a: 'Most instructors report saving several hours of planning time during their very first week of use.'
}, {
  q: 'Can I print the materials for poolside use?',
  a: 'Yes, all guides, lesson plans, and the Quick Plan Cards are printer-friendly. Many coaches print them and laminate them for the pool deck.'
}, {
  q: 'Is this a one-time payment or a subscription?',
  a: 'It is a one-time payment of $27. You get lifetime access to the entire SWIMMING COACH READY™ system and all bonuses with no recurring fees.'
}, {
  q: 'What age groups is this suitable for?',
  a: 'The frameworks and drills cover all ages, from toddlers and young children to adult learners and advanced swimmers.'
}, {
  q: 'Do I get access to the bonuses immediately?',
  a: 'Yes! All 5 premium bonuses are included with your purchase today and will be delivered instantly alongside the main system.'
}, {
  q: 'What is the refund process if I am not satisfied?',
  a: 'Simply email us within 7 days of your purchase, and we will issue a full, no-questions-asked refund. Your investment is 100% risk-free.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-8 px-4 sm:px-6 bg-white" data-id="element-37">
      <div className="text-center mb-6" data-id="element-38">
        <h2 className="text-2xl sm:text-3xl font-heading font-black text-brand-navy mb-2 uppercase leading-tight" data-id="element-39">
          FREQUENTLY ASKED QUESTIONS
        </h2>
      </div>

      <div className="flex flex-col gap-2" data-id="element-40">
        {faqs.map((faq, i) => <div key={i} className="bg-brand-gray border border-brand-gray rounded-md overflow-hidden shadow-sm" data-id="element-41">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-4 py-3.5 text-left flex justify-between items-center hover:bg-brand-pool/10 transition-colors gap-3" data-id="element-42">
              <span className="font-bold text-brand-navy text-sm leading-tight" data-id="element-43">
                {faq.q}
              </span>
              <ChevronDownIcon className={`w-4 h-4 text-brand-pool transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-44" />
            </button>

            {openIndex === i && <div className="px-4 pb-4 pt-0 text-brand-navy/80 text-sm leading-snug border-t border-brand-navy/5 mt-1 pt-3" data-id="element-45">
                {faq.a}
              </div>}
          </div>)}
      </div>
    </section>;
}